import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CampaignModuleGate } from "@/features/admin/campaigns/campaign-module-gate";
import { CampaignEditor } from "@/features/admin/campaigns/editor";
import { maskSearchFragment } from "@/features/shared/route-masking";

const searchSchema = z.object({
  ...maskSearchFragment,
});

export const Route = createFileRoute("/admin/campaigns/$campaignId")({
  validateSearch: searchSchema,
  component: CampaignEditorRoute,
});

function CampaignEditorRoute() {
  const { campaignId } = Route.useParams();
  return (
    <CampaignModuleGate>
      <CampaignEditor campaignId={campaignId} />
    </CampaignModuleGate>
  );
}
